module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-select', {
    attrs: {
      "items": _vm.typeOptions,
      "disabled": _vm.isTypeDisabled,
      "label": "Type",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.type),
      callback: function($$v) {
        _vm.$set(_vm.element, "type", $$v)
      },
      expression: "element.type"
    }
  }), _vm._v(" "), (_vm.isVisible('title')) ? _c('v-text-field', {
    attrs: {
      "label": "Title",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.title),
      callback: function($$v) {
        _vm.$set(_vm.element, "title", $$v)
      },
      expression: "element.title"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('name')) ? _c('v-text-field', {
    attrs: {
      "label": "Name",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.name),
      callback: function($$v) {
        _vm.$set(_vm.element, "name", $$v)
      },
      expression: "element.name"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Display")]), _vm._v(" "), (_vm.isVisible('width')) ? _c('v-slider', {
    staticClass: "mr-1",
    attrs: {
      "hide-details": "",
      "label": _vm.widthLabel,
      "step": 10
    },
    model: {
      value: (_vm.element.width),
      callback: function($$v) {
        _vm.$set(_vm.element, "width", $$v)
      },
      expression: "element.width"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('height')) ? _c('v-select', {
    attrs: {
      "items": _vm.heightOptions,
      "label": "Height",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.height),
      callback: function($$v) {
        _vm.$set(_vm.element, "height", $$v)
      },
      expression: "element.height"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('background-colour')) ? _c('ColourBar', {
    attrs: {
      "colours": ['#eee', '#ddd', '#dff3fe'],
      "label": "Background Colour"
    },
    model: {
      value: (_vm.element.background),
      callback: function($$v) {
        _vm.$set(_vm.element, "background", $$v)
      },
      expression: "element.background"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Data")]), _vm._v(" "), (_vm.isVisible('table')) ? _c('v-text-field', {
    attrs: {
      "label": "Table"
    },
    model: {
      value: (_vm.element.table),
      callback: function($$v) {
        _vm.$set(_vm.element, "table", $$v)
      },
      expression: "element.table"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('default-value-textarea')) ? _c('v-textarea', {
    attrs: {
      "rows": "3",
      "label": "Default Value"
    },
    model: {
      value: (_vm.element.defaultValue),
      callback: function($$v) {
        _vm.$set(_vm.element, "defaultValue", $$v)
      },
      expression: "element.defaultValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isVisible('options')) ? _c('v-text-field', {
    attrs: {
      "label": "Available Options",
      "hide-details": ""
    },
    model: {
      value: (_vm.element.options),
      callback: function($$v) {
        _vm.$set(_vm.element, "options", $$v)
      },
      expression: "element.options"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section-heading vertical-margin"
  }, [_vm._v("Actions")]), _vm._v(" "), (_vm.isVisible('add-column')) ? _c('v-btn', {
    staticClass: "element-action-button",
    attrs: {
      "outline": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.buttonClicked('add-column')
      }
    }
  }, [_vm._v("Add Column")]) : _vm._e(), _vm._v(" "), (_vm.isVisible('save-section')) ? _c('v-btn', {
    staticClass: "element-action-button",
    attrs: {
      "outline": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.buttonClicked('save-section')
      }
    }
  }, [_vm._v("Save Section")]) : _vm._e(), _vm._v(" "), (_vm.isVisible('clone-element')) ? _c('v-btn', {
    staticClass: "element-action-button",
    attrs: {
      "outline": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.buttonClicked('clone-element')
      }
    }
  }, [_vm._v("Clone Element")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c77b56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/builder/EditPanel.vue
// module id = 2481
// module chunks = 1